import React from "react";
import BlogHome from "./BlogHome";
import BlogTestimonoals from "./BlogTestimonoals";
import Blogs from "./Blogs";
import Footer from "../Footer/Footer";
import Homepage from "./pages/homepage/Homepage";

const Blog = ({ blogs }) => {
  return (
    <>
      <BlogHome />
      <Homepage />

      <BlogTestimonoals />
      <Blogs />

      <Footer />
    </>
  );
};

export default Blog;
